export enum AdminScope {
  REPORT = 'report',
  CAMPAIGN_RESUME = 'campaign-resume',
  CONTRACTS = 'contracts',
  SUBSCRIPTIONS = 'subscriptions',
}
